import { useCallback, useEffect, useRef, useState } from 'react';

import {
  applyAppVersionUpdate,
  evaluateAppVersion,
} from '../../../bootstrap/appVersionCheck';

const VERSION_CHECK_INTERVAL_MS = 30 * 1000;

export default function useAppVersionCheck() {
  const [isLatestVersion, setIsLatestVersion] = useState(true);
  const pendingVersionRef = useRef('');

  const runVersionCheck = useCallback(async () => {
    try {
      const result = await evaluateAppVersion();
      pendingVersionRef.current = result.serverVersion;
      setIsLatestVersion(result.isLatestVersion);
    } catch (error) {
      console.error('Falha ao verificar versão da aplicação', error);
    }
  }, []);

  const emptyCacheStorage = useCallback(async () => {
    const version = pendingVersionRef.current;
    if (!version) {
      window.location.reload();
      return;
    }
    await applyAppVersionUpdate(version);
  }, []);

  useEffect(() => {
    runVersionCheck();

    const intervalId = window.setInterval(runVersionCheck, VERSION_CHECK_INTERVAL_MS);
    const handleFocus = () => runVersionCheck();
    const handleVisibility = () => {
      if (document.visibilityState === 'visible') {
        runVersionCheck();
      }
    };

    window.addEventListener('focus', handleFocus);
    document.addEventListener('visibilitychange', handleVisibility);

    return () => {
      window.clearInterval(intervalId);
      window.removeEventListener('focus', handleFocus);
      document.removeEventListener('visibilitychange', handleVisibility);
    };
  }, [runVersionCheck]);

  return {
    isLatestVersion,
    emptyCacheStorage,
  };
}
